import { environment } from './../../environments/environment';
import { Injectable } from '@angular/core';
import { ConstantConfigService } from '../services/constant-config.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import {map} from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';
import {CompanyAccessLimit} from "../pages/company-access-limit/company-access-limit.model";
import {EmailTemplate} from "../pages/email-template/email-template.model";
import { Router,ActivatedRoute } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class DataService {
  _baseURL : string;
  _imageURL : string;
  messageObj : any = {};

  /*public data$: BehaviorSubject<any> = new BehaviorSubject({});

  updateData(selectedCompany, type,payment_mode,updateTimestamp): Observable<EmailTemplate[]>{
    return this.http.post<[]>(this._baseURL+"/requestListing",{"company_id":selectedCompany, "activeTab":type,"payment_mode":payment_mode,"updateTimestamp":updateTimestamp}).pipe(
      map((response: Response) => {
        return data;
      });
    );
  }*/


  private dataSubject: BehaviorSubject<[]> = new BehaviorSubject([]);
  data$: Observable<[]> = this.dataSubject.asObservable();

  constructor(private http: HttpClient,private router: Router) {

    this._baseURL = ConstantConfigService.baseURL;
    this._imageURL = ConstantConfigService.ImageUrl;
   }

  updateData(selectedCompany, type,payment_mode,updateTimestamp): Observable<any>  {
      return this.getData(selectedCompany, type,payment_mode,updateTimestamp).do((data) => {
          this.dataSubject.next(data);
      });
  }

   // My data is an array of model objects
  getData(selectedCompany, type,payment_mode,updateTimestamp): Observable<any>{
      return this.http.post(this._baseURL+"/requestListing",{"company_id":selectedCompany, "activeTab":type,"payment_mode":payment_mode,"updateTimestamp":updateTimestamp,"action":"autorefresh"}).pipe(map(data => {
        if(data['success'] == true){
          //console.log(data['message']);
         return data['message'];
          //return data['data'].map(data => new CompanyAccessLimit().deserialize(data))
        } else {
          this.messageObj = {
            'message' : data['message'],
            "success" : false
          }
          return Observable.of(this.messageObj);
        }

       // return response.json();
        /*let data = response.json() && response.json().your_data_objects;
        if(data){
            return data;
        }*/
    }))

  }

  registerUser(data){
    //console.log("datadatadatadatadatadatadata",data);
    return this.http.post(this._baseURL+"/register-user",{"full_name":data.first_name+' '+data.last_name,"first_name":data.first_name,'middle_name' :'','last_name' :data.last_name,"email":data.email,'password' :'freeflow'});
  }

  getFreeFlowLimit(){
    return this.http.get(this._baseURL+"/getFreeFlowLimit");
  }

  getDocsUploaded(userId,time_period){
    return this.http.get(this._baseURL+'/getDocsUploaded/'+userId+'/'+time_period);
  }

  templateFreeFlow(company_id,data){
    return this.http.post(this._baseURL+'/company/'+company_id+'/template/free-flow',data);
  }

  // getPdfpageWiseNew(company_id,document_id,document_file,i){
  //   return new Promise((resolve) => {
  //     setTimeout(() => {
  //       this.http.post(this._baseURL+'/company/template/getPdfpageWise/'+company_id,{"document_id":document_id,"document_file":document_file,"page_number":(i)});
  //       resolve();
  //     }, Math.floor(Math.random() * 1000));
  // });
    //return await this.http.post(this._baseURL+'/company/template/getPdfpageWise/'+company_id,{"document_id":document_id,"document_file":document_file,"page_number":(i)}).toPromise();
  //}

  getPdfpageWise(company_id,document_id,document_file,i){
    return this.http.post(this._baseURL+'/company/template/getPdfpageWise/'+company_id,{"document_id":document_id,"document_file":document_file,"page_number":(i)});
  }

  uploadDocument(company_id,data){
    return this.http.post(this._baseURL+'/company/document/upload/'+company_id,data);
  }

  updateExistingTemplatePDF(company_id,data){
    return this.http.post(this._baseURL+'/company/template/updatetemplatepdf/'+company_id,data);
  }

  uploadSamplePdf(company_id,data){
    return this.http.post(this._baseURL+'/company/'+company_id+'/document/uploadsamplepdf',data);
  }

  uploadCut(company_id,doc_file,sample_name,request_type,page_action?){
    return this.http.post(this._baseURL+"/company/template/uploadCutimageBackground/"+company_id,{"document_file":doc_file,"doc_title":sample_name,"document_status":request_type,"page_action":page_action});
  }

  uploadCutWithPagination(company_id,doc_file,sample_name,request_type,startPage = 1, endPage = 1,saved_document_id=0){
    return this.http.post(this._baseURL+"/company/template/uploadCutimageBackground/"+company_id,{"document_file":doc_file,"doc_title":sample_name,"document_status":request_type,startPage: startPage,
      endPage: endPage,saved_document_id:saved_document_id,action:'freeflow',responsetype:'pagecount'});
  }


  uploadCutQuickFlow(company_id,doc_file,sample_name,request_type,uploaded_file_name,responsetype,document_id,signature_option,signee_option_value,action_type,signature_type,offline_document_id='',deal_id='',deal_company_id='',dealhub_request=0,dealhub_quote_no='Q0',action_panel=0){
    return this.http.post(this._baseURL+"/company/template/uploadCutimageBackground/"+company_id,{"document_file":doc_file,"doc_title":sample_name,"document_status":request_type,"uploaded_file_name":uploaded_file_name,"responsetype":responsetype,"document_id":document_id,"signature_option":signature_option,"signee_option":signee_option_value,"signature_type":signature_type, "action_type":action_type,"offline_document_id":offline_document_id,"deal_id":deal_id,"deal_company_id":deal_company_id,"action":"quickflow","dealhub_request":dealhub_request,"quote_number":dealhub_quote_no,"action_panel":action_panel});
  }

  getPageCountQuickFlow(postData){
    return this.http.post(this._baseURL+"/company/get-pdf-page-count",postData);
  }

  uploadCutQuickFlowNew(company_id,doc_file,sample_name,request_type,uploaded_file_name,responsetype,document_id,signature_option,signee_option_value,action_type,signature_type,offline_document_id='',deal_id='',deal_company_id='',dealhub_request=0,dealhub_quote_no='Q0',action_panel=0,startPage = 1, endPage = 1,saved_document_id=0){
      const postData = {
        document_file: doc_file,
        doc_title: sample_name,
        document_status: request_type,
        uploaded_file_name: uploaded_file_name,
        responsetype: responsetype,
        document_id: document_id,
        signature_option: signature_option,
        signee_option: signee_option_value,
        signature_type: signature_type,
        action_type: action_type,
        offline_document_id: offline_document_id,
        deal_id: deal_id,
        deal_company_id: deal_company_id,
        action: 'quickflow',
        dealhub_request: dealhub_request,
        quote_number: dealhub_quote_no,
        action_panel: action_panel,
        startPage: startPage,
        endPage: endPage,
        saved_document_id:saved_document_id
    };
    console.log('postData',postData);

    return this.http.post(`${this._baseURL}/company/template/uploadCutimageBackground/${company_id}`, postData);
  }

  getPdfNoOfpages(company_id,doc_file,doc_id){
    return this.http.post(this._baseURL+"/company/template/getPdfNoOfpages/"+company_id,{"document_file":doc_file,"document_id":doc_id});
  }

  getNoOfpagesforPDF(company_id,doc_file){
    return this.http.post(this._baseURL+"/company/template/getNoOfpagesforpdf/"+company_id,{"document_file":doc_file});
  }

  getNoOfpagesforExistingPDF(company_id,doc_file){
    return this.http.post(this._baseURL+"/company/template/getNoOfpagesforexistingpdf/"+company_id,{"document_file":doc_file});
  }

   uploadDocumentMerge(doc_id,data){
    return this.http.post(this._baseURL+'/company/document/merge/'+doc_id,data);
  }

  checkFileFormatOnlyPDF(data): Observable<any[]>{
    console.log("size====",data.target.files[0].size);
    if(typeof data.target!="undefined" && typeof data.target.files!="undefined" && data.target.files[0].size>37050640){
      this.messageObj = {
        'message' : "Max File Size should be 35MB",
        "success" : false
      }
      return Observable.of(this.messageObj);
    }
    else if(typeof data.target!="undefined" && typeof data.target.files!="undefined" && data.target.files[0].type=='application/pdf'){
      this.messageObj = {
          'message' : "valid",
          "success" : true
      }

      return Observable.of(this.messageObj);
    }
    else{
      this.messageObj = {
        'message' : "Please upload pdf only > Sorry this document type is not supported. Please only upload PDF file type",
        "success" : false
      }
      return Observable.of(this.messageObj);
    }
  }

 checkFileFormat(data, allowLargeFile?: boolean): Observable<any[]>{
 
    const maxFileSize = allowLargeFile ? 100 * 1024 * 1024 : 20 * 1024 * 1024;
 
    if(typeof data.target!="undefined" && typeof data.target.files!="undefined" && data.target.files[0].size>maxFileSize){ //20050640
      this.messageObj = {
        message: `Max File Size should be ${allowLargeFile ? '100MB' : '20MB'}`,
        "success" : false
      }
      return Observable.of(this.messageObj);
      //return Observable.of(this.messageObj);
    }
    else if(typeof data.target!="undefined" && typeof data.target.files!="undefined" && (data.target.files[0].type=='application/pdf' || data.target.files[0].type=='image/png' || data.target.files[0].type=='image/jpg' || data.target.files[0].type=='image/jpeg')){
      this.messageObj = {
          'message' : "valid",
          "success" : true
      }

      return Observable.of(this.messageObj);
    }
    else{
      this.messageObj = {
        'message' : "Please upload pdf,jpg,jpeg,png only > Sorry this document type is not supportd. Please only upload PDF, JPG, and PNG  files types",
        "success" : false
      }
      return Observable.of(this.messageObj);
    }
  }

  checkFileFormatCRM(data,type): Observable<any[]>{
    if(typeof type=="undefined"){
      type = 0;
    }
    if(type==0){
      //2097152
      if(typeof data.target!="undefined" && typeof data.target.files!="undefined" && data.target.files[0].size>10485760){
        this.messageObj = {
          'message' : "Max File Size should be 10MB",
          "success" : false
        }
        return Observable.of(this.messageObj);
      }else if(typeof data.target!="undefined" && typeof data.target.files!="undefined" && data.target.files[0].type=='application/pdf'){
        this.messageObj = {
            'message' : "valid",
            "success" : true
        }
        return Observable.of(this.messageObj);
      }else{
        this.messageObj = {
          //'message' : "Please upload pdf only > Sorry this document type is not supportd. Please only upload PDF files types",
          'message' : "Sorry only PDF files are supported at this time.",
          "success" : false
        }
        return Observable.of(this.messageObj);
      }
    }else{
      //console.log(data.file.size);
      if(typeof data.file!="undefined" ){
        let size =  parseInt(data.file.size);
        if(size > 10485760){
          this.messageObj = {
            'message' : "Max File Size should be 10MB",
            "success" : false
          }
          return Observable.of(this.messageObj);
        }else if(data.file.type=="application/pdf"){
            this.messageObj = {
              'message' : "valid",
              "success" : true
          }
          return Observable.of(this.messageObj);
        }else{
          this.messageObj = {
            //'message' : "Please upload pdf only > Sorry this document type is not supportd. Please only upload PDF files types",
            'message' : "Sorry only PDF files are supported at this time.",
            "success" : false
          }
          return Observable.of(this.messageObj);
        }
      }else{
        this.messageObj = {
          //'message' : "Please upload pdf only > Sorry this document type is not supportd. Please only upload PDF files types",
          'message' : "Sorry only PDF files are supported at this time.",
          "success" : false
        }
        return Observable.of(this.messageObj);
      }
    }
  }

  checkExcelFileFormat(data): Observable<any[]>{
    if(data.target.files[0].size>2097152){
      this.messageObj = {
        'message' : "Max File Size should be 2MB",
        "success" : false
      }
      return Observable.of(this.messageObj);
    }
    else if(data.target.files[0].type=='application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'){
      this.messageObj = {
          'message' : "valid",
          "success" : true
      }

      return Observable.of(this.messageObj);
    }
    else{
      this.messageObj = {
        'message' : "Please upload .xlsx only",
        "success" : false
      }
      return Observable.of(this.messageObj);
    }
  }


  documentList(company_id,type, extraParam?: any,showTemplateBlocks?:any){
    let payload: any = { listing_type: type };

    if (extraParam) {
      payload = { ...payload, ...extraParam };
    }

    if (showTemplateBlocks) {
      payload = { ...payload, ...showTemplateBlocks };
    }

    return this.http.post(this._baseURL+"/company/"+company_id+"/document/listing",payload);
  }

  getgroupListing(company_id){
    return this.http.post(this._baseURL+"/company/"+company_id+"/group/listing",{"action":"complete"});
  }
  store(company_id,postData){
    return this.http.post(this._baseURL+"/company/template/store/"+company_id,postData);
  }

  saveTemplate(company_id,postData){
    return this.http.post(this._baseURL+"/company/template/save/"+company_id,postData);
  }

  saveTemplateCustomFields(company_id,customFDFFields,matrixposVar,matrixpos4Var,document_id){
    return this.http.post(this._baseURL+"/company/template/saveTemplateCustomFields/"+company_id,{"pageobj":customFDFFields,"matrixpos":matrixposVar,"matrixpos4":matrixpos4Var,"document_id":document_id});
  }

  sendRequest(company_id,postData){
    return this.http.post(this._baseURL+"/company/sendRequest/"+company_id,postData);
  }

  checkDocumentSentToGroup(document_id,group_id){
    return this.http.post(this._baseURL+"/checkdocumentwithgroup",{"document_id":document_id,"group_id":group_id});
  }

  applyCredits(postData){
    return this.http.post(this._baseURL+"/apply-credit-to-user",postData);
  }

  groupList(){
    return this.http.get(this._baseURL+'/groupListing');
  }

  getCountryPhoneCode(){
    return this.http.get(this._baseURL+'/get-country-phone-code');
  }

  getApprovalUserList(){
    return this.http.get(this._baseURL+'/getApprovalListing');
  }

  getTeamListing(){
    return this.http.get(this._baseURL+'/getTeamListing');
  }

  getKitList(company_id){
    return this.http.get(this._baseURL+'/company/kit-listing/' + company_id );
  }

  getGroupCustomFields(company_id,groupId){
    return this.http.get(this._baseURL+'/company/group/customFields/'+company_id+'/'+groupId);
  }

  groupStat(company_id,groupId){
    return this.http.get(this._baseURL+'/company/group/'+company_id+'/'+groupId);
  }

  getAllCustomField(){
    return this.http.get(this._baseURL+'/custom-field-type-all');
  }

  getTFASettings(){
    return this.http.get(this._baseURL+'/getDefaultTwoFactorAuthOptions');
  }

  enableTwoFactor(userid,companyid,status){
    return this.http.post(this._baseURL+"/switchMyself",{"user_id":userid,"companyid":companyid,"status":status});
  }

  verifyOtpGoogle(google_otp,google_secret,email,company_id){
    return this.http.post(this._baseURL+"/verifyOtp",{'google_opt' :google_otp.replace(/ /g, ''),'google_secret':google_secret,'email':email,'company_id':company_id});
  }

  checkUserPhoneExist(){
    return this.http.get(this._baseURL+'/checkUserPhoneExist');
  }

  sendSmsOtpToUser(phone, email, phoneCode,is_signee="0",process_id="",loginrequest='',companyid=''){
    return this.http.post(this._baseURL+"/sentSmsOtp",{"phone":phone, "email":email, "phoneCode":phoneCode,"is_signee":is_signee,"process_id":process_id,'loginrequest':loginrequest,'companyid':companyid});
  }

  resendEmailToUser(){
    return this.http.post(this._baseURL+"/resendEmailOtp",{"action":"resend"});
  }

  verifyOtpSms(tempstorenumber,sms_opt){
    return this.http.post(this._baseURL+"/smsOtpVerify",{'phone' :tempstorenumber,'sms_opt' :sms_opt.replace(/ /g, '')});
  }

  updateSecurityPreference(securityoption){
    return this.http.post(this._baseURL+"/updateSecurityPreference",{'securityoption':securityoption});
  }

  makeOtpSmsDisabled(Option){
    return this.http.post(this._baseURL+"/smsOtpDisabled",{'option' :Option});
  }

  getRequests(selectedCompany, type,payment_mode,updateTimestamp,loadrecords,filter=''){
    return this.http.post(this._baseURL+"/requestListing",{"company_id":selectedCompany, "activeTab":type,"payment_mode":payment_mode,"updateTimestamp":updateTimestamp,"loadrecords":loadrecords,"filter":filter});
  }

  getRequestsV1(selectedCompany, type,payment_mode,updateTimestamp,loadrecords,last_index,days,filter=''){
    return this.http.post(this._baseURL+"/requestListing",{"company_id":selectedCompany, "activeTab":type,"payment_mode":payment_mode,"updateTimestamp":updateTimestamp,"loadrecords":loadrecords,"lastindex":last_index,"days":days,"filter":filter});
  }


  getRequestsCRM(postData){
    return this.http.post(this._baseURL+"/requestListing",postData);
  }

  getRequestsWatermark(request_id,user_document_id,value){
    return this.http.post(this._baseURL+"/sendSigneePdf",{"request_id":request_id,"user_document_id":user_document_id,"watermark_status":value});
  }

  getCompanyNeedApprovalDocuments(company_id,val){
    return this.http.get(this._baseURL+'/need-Approval-Listing/'+company_id+'/'+val);
  }

  getDocumentDetail(user_document_id,document_id,status_code){
    return this.http.get(this._baseURL+'/viewDocumentDetail/'+user_document_id+'/'+document_id+'/'+status_code);
  }

  rejectDocument(userDocumentId,documentId,reasonforrejection){
    return this.http.post(this._baseURL+"/reject_doc",{"user_document_id":userDocumentId,"document_id":documentId,"reject_note":reasonforrejection});
  }

  sendBackDocument(userDocumentId,documentId,reasonforrejection){
    return this.http.post(this._baseURL+"/sendback_doc",{"user_document_id":userDocumentId,"document_id":documentId,"reject_note":reasonforrejection});
  }

  approveDocument(user_document_id,document_id){
    return this.http.get(this._baseURL+'/approve_doc/'+user_document_id+'/'+document_id);
  }

  saveExpiryDate(document_id,expiry_date){
    return this.http.post(this._baseURL+"/change-expire-date",{"user_document_id":document_id,"expire_date":expiry_date});
  }

  getUserUpladDocumentRequest(){
    return this.http.get(this._baseURL+'/user-upload-requests');
  }

  getExpiredRequests(company_id){
    return this.http.get(this._baseURL+'/expired-request-listing/'+company_id);
  }

  updateRequest(request_id,date,useresend=0,postData?){
    return this.http.post(this._baseURL+"/update_request",{"request_id":request_id,"date":date,"useresend":useresend,"post_data":postData});
  }

  getCompanySessionSetting(){
    return this.http.get(this._baseURL+'/company-session-setting');
  }

  checkPlanLimit(planLimit, currentCount, type, column_name, extraParam,present_req){
    //console.log(planLimit, currentCount, type, column_name, extraParam);
    //if(currentCount == 'NA' && extraParam['plan_status'] == 1 || extraParam['plan_status'] == 1){
    if(currentCount == 'NA'){
      return this.http.get(this._baseURL+'/check-plan-limit/'+type+'/'+column_name);
    }
    else{
      var response = '';
				if((planLimit > currentCount && extraParam['plan_status'] == 1 )|| extraParam['plan_status'] == 2){
					response = 'true';
					return Observable.of(response);
				}
				else{
					//console.log('herer');
					response = 'false';
					return Observable.of(response);
				}
    }

  }

  addTeam(postData){
    return this.http.post(this._baseURL+"/saveTeam",postData);
  }

  getTeamListingArr(){
    return this.http.get(this._baseURL+'/getTeamListingArr');
  }

  getTemplateList(company_id){
    return this.http.get(this._baseURL+'/company/company-template-listing-counter/'+company_id);
  }

  getTemplateListArchive(company_id){
    return this.http.get(this._baseURL+'/company/company-template-listing-archive/'+company_id);
  }

  getSampleDocs(){
    return this.http.get(this._baseURL+'/getSampleDocument');
  }

  submitSampleRequest(data){
    return this.http.post(this._baseURL+'/submitSampleRequest',data);
  }

  getSMSSecuritySetting(){
    return this.http.get(this._baseURL+'/get-sms-setting');
  }

  getCompanyInfo(company_id){
    return this.http.get(this._baseURL+'/getCompanyInfo/'+company_id);
  }

  saveSecurityAlerts(postData){
    return this.http.post(this._baseURL+'/save-sms-setting',postData);
  }
  saveSecurityOption(postData){
    return this.http.post(this._baseURL+'/save-sms-setting',postData);
  }

  updateCompanyInfo(name,email,address,phone,company_name,website_url,ip_address,id,userid,state,city,zip){
    return this.http.post(this._baseURL+'/updateCompany/'+id, {"name":name,"email":email,"address":address,"phone":phone,"company_name":company_name,"website_url":website_url,"ip_address":ip_address,"user_id":userid,"state":state,"city":city,"zip":zip});
  }

  companySessionInfo(company_id){
    return this.http.get(this._baseURL+'/edit-com-session-setting/'+company_id);
  }

  saveSessionSetting(postData){
    return this.http.post(this._baseURL+'/save-session-setting', postData);
  }

  userRole(){
    return this.http.get(this._baseURL+'/getUserRoles');
  }

  getPhoneCodeByIP(){
    return this.http.get(this._baseURL+'/get-dial-code-ip');
  }

  saveUser(name,title,email,address,phone,role,company_id,city,state,zip,digitalConsent){
    return this.http.post(this._baseURL+'/saveuser', {"name":name,"title":title,"email":email,"address":address,"phone":phone,"role":role,"company_id":company_id,"city":city,"state":state,"zip":zip,"digitalconsent":digitalConsent});
  }

  checkemailexists(email,id=''){
    return this.http.post(this._baseURL+'/checkemailexists', {"email":email,"userid":id});
  }
  checkemailexistsRegister(email){
    return this.http.post(this._baseURL+'/checkemailexistsregister', {"email":email});
  }

  checkemailexistssignee(email,id='',compid){
    return this.http.post(this._baseURL+'/checkemailexistssignee', {"email":email,"userid":id,"company_id":compid});
  }

  getUserInfo(userid){
    return this.http.get(this._baseURL+'/getUserInfo/'+userid);
  }

  updateUser(name,title,email,address,phone,role,company_id,id, city, state, zip){
    return this.http.patch(this._baseURL+'/updateUser/'+id, {"name":name,"title":title,"email":email,"address":address,"phone":phone,"role":role,"company_id":company_id, "city": city, "state": state, "zip": zip});
  }

  getAllUsers(company_id){
    return this.http.get(this._baseURL+'/getAllUsers/'+company_id);
  }
  getCompleteUserData(company_id){
    return this.http.get(this._baseURL+'/getAllUsers/'+company_id+'/all');
  }

  getAllSignees(company_id){
    return this.http.get(this._baseURL+'/get-all-signees/'+company_id);
  }
  getCompleteSigneeData(company_id){
    return this.http.get(this._baseURL+'/get-all-signees/'+company_id+'/all');
  }

  updateUserStatus(id,status){
    return this.http.post(this._baseURL+'/changeUserStatus', {"user_id":id,"status":status});
  }

  deleteUser(userid){
    return this.http.get(this._baseURL+'/remove-user/'+userid);
  }

  updateUserApproverStatus(id,status){
    return this.http.post(this._baseURL+'/changeApproverStatus', {"user_id":id,"apstatus":status});
  }

  resendInvite(userId, c_id){
    return this.http.post(this._baseURL+'/resend-user-invite', {"user_id":userId, 'c_id': c_id});
  }

  unBlockTFA(userId, c_id){
    return this.http.post(this._baseURL+'/unblockTfa', {"user_id":userId, 'c_id': c_id});
  }

  getCompnies(){
    return this.http.get(this._baseURL+'/company');
  }

  updateBulkUserStatus(ids,status){
    return this.http.post(this._baseURL+'/changesBulkStatus', {"user_ids":ids,"status":status});
  }

  deactivateHubspot(){
    var postData = "";
    return this.http.post(this._baseURL+'/deactivate-hubspot',postData);
  }

  getDealvalue(){
    return this.http.get(this._baseURL+'/get-deal-value');
  }

  getDealValuesSettings(){
    return this.http.get(this._baseURL+'/get-deal-value');
  }

  getDealValuesSettingsUpdated(){
    return this.http.get(this._baseURL+'/get-deal-value-updated');
  }

  getCompanyLastSavedSchedule(postData){
    return this.http.post(this._baseURL+'/get-company-last-schedule',postData);
  }

  checkHubSpot(){
    var postData;
    return this.http.post(this._baseURL+'/check-hupspot-token',postData);
  }

  checkHubSpotTemplate(){
    return this.http.get(this._baseURL+'/get-hubSpot-template');
  }

  getPipelinesList(companyid,getresponse){
    return this.http.get(this._baseURL+'/get-all-pipelines/'+companyid+'/'+getresponse);
  }

  getDealStages(companyid,pipelineId,getresponse){
    return this.http.get(this._baseURL+'/get-all-dealstages/'+companyid+'/'+pipelineId+'/'+getresponse);
  }

  getPipelinesListYounium(companyid,getresponse,environment){
    return this.http.get(this._baseURL+'/get-all-pipelines/'+companyid+'/'+getresponse+'/'+environment);
  }

  getDealStagesYounium(companyid,pipelineId,getresponse,environment){
    return this.http.get(this._baseURL+'/get-all-dealstages/'+companyid+'/'+pipelineId+'/'+getresponse+'/'+environment);
  }

  activateWidget(){
    var postData;
    return this.http.post(this._baseURL+'/get-all-dealstages',postData);
  }

  deleteCrmExt(hapi_keys){
    var postData = {
      hapi_key: hapi_keys,
    };
    return this.http.post(this._baseURL+'/delete-crm-ext',postData);
  }

  enableCrmExt(){
    var postData = {
    };
    return this.http.post(this._baseURL+'/enable-crm',postData);
  }

  saveDiscountOption(postData){
    return this.http.post(this._baseURL+'/save-discount-option',postData);
  }

  saveDiscountOptionUpdated(postData){
    return this.http.post(this._baseURL+'/save-discount-option-updated',postData);
  }

  saveDealCreateUpdated(postData){
    return this.http.post(this._baseURL+'/save-deal-create-setting',postData);
  }

  saveDealLifeCycleSetting(postData){
    return this.http.post(this._baseURL+'/save-deal-life-cycle-setting',postData);
  }

  saveDealHubEmailSetting(postData){
    return this.http.post(this._baseURL+'/save-deal-hub-email-setting',postData);
  }

  createHubSpot(postData){
    return this.http.post(this._baseURL+'/create-crm',postData);
  }

  checkHupspot(postData){
    return this.http.post(this._baseURL+'/check-hupspot',postData);
  }

  createToken(postData){
    return this.http.post(this._baseURL+'/create-token',postData);
  }

  enableGSuiteAPISettings(postData){
    return this.http.post(this._baseURL+'/enable-gsuite-token',postData);
  }

  createGmailToken(postData){
    return this.http.post(this._baseURL+'/create-gmail-token',postData);
  }

  createGoogleToken(postData){
    return this.http.post(this._baseURL+'/create-google-token',postData);
  }

  storetoGoogleDrive(postData){
    return this.http.post(this._baseURL+'/store-in-google-drive',postData);
  }

  getManageKeysList(postData){
    return this.http.post(this._baseURL+'/manage-keys',postData);
  }

  saveNewKey(postData){
    return this.http.post(this._baseURL+'/add-key',postData);
  }

  setExpireKey(postData){
    return this.http.post(this._baseURL+'/set-expire',postData);
  }

  deleteAppKey(postData){
    return this.http.post(this._baseURL+'/delete-key',postData);
  }

  refreshAppKey(postData){
    return this.http.post(this._baseURL+'/refresh-key',postData);
  }

  editAppKey(postData){
    return this.http.post(this._baseURL+'/edit-key',postData);
  }

  templateVersion(company_id,template_id,type,templatetitle){
    return this.http.post(this._baseURL+'/company/'+company_id+'/template/version',{'document_id':template_id,'type':type,'templatetitle':templatetitle});
  }

  editTemplate(company_id,doc_id){
    return this.http.get(this._baseURL+'/template/'+company_id+'/edit/'+doc_id);
  }

  updateTemplate(postData){
    return this.http.post(this._baseURL+"/template/update",postData);
  }

  updateTemplateCRM(postData){
    return this.http.post(this._baseURL+"/field/updateCRM",postData);
  }

  getAdminUserEmails(){
    return this.http.get(this._baseURL+"/addSecondaryEmail");
  }

  addSecondaryEmail(email){
    return this.http.post(this._baseURL+"/addSecondaryEmail",{"email":email});
  }

  deleteUserSecondaryEmail(email){
    return this.http.post(this._baseURL+"/deleteSecondaryEmail",{"email":email});
  }

  sendReminderEmail(email){
    return this.http.post(this._baseURL+"/SendRemiderEmail",{"email":email});
  }

  setPrimaryEmail(email){
    return this.http.post(this._baseURL+"/SetPrimaryEmail",{"email":email});
  }

  updateFreeFlowLimit(peremaillimit, selected_time_period){
    return this.http.post(this._baseURL+"/updateFreeFlowLimit",{"peremaillimit":peremaillimit, 'time_period':selected_time_period});
  }

  getUserLimit(roleId){
    return this.http.get(this._baseURL+"/getUserLimitByRole/"+roleId);
  }

  updateRoleLimit(role,user_limit){
    return this.http.post(this._baseURL+'/updateRoleLimit', {"role":role,"user_limit":user_limit});
  }

  getApiLimitSettings(){
    return this.http.get(this._baseURL+"/getApiLimitSettings");
  }

  saveApiLimitSettings(public_api_limit,private_api_limit){
    return this.http.post(this._baseURL+'/saveApiLimitSettings', {"private_api_limit":private_api_limit,"public_api_limit":public_api_limit});
  }

  getCreditvstasksSettings(){
    return this.http.get(this._baseURL+"/creditvstasks-setting");
  }

  saveCreditvsTask(postData){
    return this.http.post(this._baseURL+"/creditvstasks-setting",postData);
  }

  getPasswordSettings(){
    return this.http.get(this._baseURL+"/password-policy-settings");
  }

  getPasswordSettingsCompany(){
    return this.http.get(this._baseURL+"/password-policy-settings-company");
  }

  getexistingGooglesettings(){
    return this.http.get(this._baseURL+"/google-drive-settings");
  }

  getsavedGooglesettings(){
    return this.http.get(this._baseURL+"/google-drive-saved-settings");
  }

  disconnectFolderGoogleSettings(postData){
    return this.http.post(this._baseURL+"/disconnect-google-drive-settings",postData);
  }

  updateStorageFolderGoogleSettings(postData){
    return this.http.post(this._baseURL+"/update-google-drive-settings",postData);
  }

  enableGoogleDriveSettings(postData){
    return this.http.post(this._baseURL+"/update-google-drive-settings",postData);
  }

  getMaintenanceModeSettings(){
    return this.http.get(this._baseURL+'/get-maintenance-mode');
  }

  enableMaintenanceModeSettings(postData){
    return this.http.post(this._baseURL+"/update-maintenancemode-settings",postData);
  }

  getexistingGSuitesettings(){
    return this.http.get(this._baseURL+"/gsuite-settings");
  }

  getexistingGmailAPIsettings(){
    return this.http.get(this._baseURL+"/gmail-api-settings");
  }

  enableGmailAPISettings(postData){
    return this.http.post(this._baseURL+"/update-gmail-api-settings",postData);
  }

  confirmRequestExpire(postData){
    return this.http.post(this._baseURL+"/mark-request-as-expire",postData);
  }

  confirmRequestComplete(postData){
    return this.http.post(this._baseURL+"/mark-request-as-complete",postData);
  }

 updatePasswordSetting(postData){
    return this.http.post(this._baseURL+"/password-policy-settings",postData);
  }

  sendTemplateToCompanies(company,templateId){
    return this.http.post(this._baseURL+"/assign-doc-to-company", {"company_ids":company,"document_id":templateId});
  }

  emailTemplatelist(): Observable<EmailTemplate[]>{
    return this.http.get<EmailTemplate[]>(this._baseURL+"/email-template").pipe(
      map(data => {
        if(data['success'] == true){
          return data['message'].map(data => new EmailTemplate().deserialize(data))
        } else {
          this.messageObj = {
            'message' : data['message'],
            "success" : false
          }
          return Observable.of(this.messageObj);
        }
      })
    );
  }

  updateEmailTemplate(id, name, subject, message){
    return this.http.post(this._baseURL+"/save-email-template", {"edit_template_id":id, "email_name":name, "email_subject":subject, "message": message,"action":"savetemplate"});
  }

  saveEmailTemplate(EmailTemplate){
    return this.http.post(this._baseURL+"/save-email-template",
      {
        "email_name":EmailTemplate.name,
        "email_subject":EmailTemplate.subject,
        "message": EmailTemplate.message,
        "action":"savetemplate"
      });
  }

    /*saveEmailTemplate(name, subject, message){
    return this.http.post(this._baseURL+"/save-email-template", {"email_name":name, "email_subject":subject, "message": message,"action":"savetemplate"});
  }*/


  savekitsetting(company_id,postData){
    return this.http.post(this._baseURL+"/company/"+company_id+"/savekitsetting/1",postData);
  }

  stateList(){
    return this.http.get(this._baseURL+'/states');
  }

  companyNameAlreadyExist(name){
    return this.http.post(this._baseURL+"/companyNameExists", {"name":name});
  }

  saveCompanyDetails(name,email,address, state, city, zip,phone,company_name,ip_address,website_url,type="normal",external_registration){
    return this.http.post(this._baseURL+'/postCompanyRegister', {"name":name,"email":email,"requestor_address":address, "city":city, "state":state, "zip":zip,"phone":phone,"company_name":company_name,"ip":ip_address,"url":website_url,"type":type,'external_registration':external_registration});
  }

  saveCompanyDetails1(name,email,address, state, city, zip,phone,company_name,ip_address,website_url,type="normal",external_registration,password,company_id){
    return this.http.post(this._baseURL+'/postCompanyRegister', {"name":name,"email":email,"requestor_address":address, "city":city, "state":state, "zip":zip,"phone":phone,"company_name":company_name,"ip":ip_address,"url":website_url,"type":type,'password':password,'external_registration':external_registration,'company_id':company_id});
  }

  saveCompanyDetailsnew(name,email,company_name,type="normal",external_registration,password,company_id){
    return this.http.post(this._baseURL+'/postCompanyRegisterv1', {"name":name,"email":email,"company_name":company_name,"type":type,'password':password,'external_registration':external_registration,'company_id':company_id});
  }

  getAllCompaniesDetails(offset,limit){
    return this.http.get(this._baseURL+'/compnayListing/'+offset+'/'+limit);
  }
  getAllFeatures(){
    return this.http.get(this._baseURL+'/get-feature');
  }
  getAllFeaturesWithCompanies(){
    return this.http.get(this._baseURL+'/get-features-with-companies');
  }
  saveFeature(feature,feature_code){
    return this.http.post(this._baseURL+'/create-feature', {"feature":feature,"feature_code":feature_code});
  }

  deleteFeature(postdata){
    return this.http.post(this._baseURL+'/delete-feature',postdata);
  }

  enabledisableFeatureList(postData){
    return this.http.post(this._baseURL+'/enable-disable-features', postData);
  }

  updateFeature(postdata){
    return this.http.post(this._baseURL+'/update-feature',postdata);
  }

  generateFeatureCode(postdata){
    return this.http.post(this._baseURL+'/generate-feature-code',postdata);
  }

  updateCompanyStatus(id,status){
    return this.http.post(this._baseURL+"/change-company-status", {"company_ids":id,"status":status});
  }

  deleteCompany(companyid){
    return this.http.delete(this._baseURL+"/companies/"+ companyid)
  }

  updateBulkCompanyStatus(ids,status){
    return this.http.post(this._baseURL+"/changes-company-bulk-status", {"company_ids":ids,"status":status});
  }

  getKitListing(company_id){
    return this.http.get(this._baseURL+'/company/'+company_id+'/kit');
  }

  getKitDocsList(company_id){
    return this.http.get(this._baseURL+'/company/'+company_id+'/documents');
  }

  saveKitData(company_id, name, listings){
    return this.http.post(this._baseURL+'/company/'+company_id+'/kit',{"listing":listings, "name":name});
  }

   groupListing(company_id){
    return this.http.get(this._baseURL+"/company/group/"+company_id);
  }

  getUserCompanies(){
    return this.http.get(this._baseURL+"/getUserRoles");
  }

  saveGroup(company_id,groupName){
    return this.http.post(this._baseURL+"/company/group/"+company_id, {"name":groupName});
  }

  saveGroupSignee(companyId,groupId,signeesAssigned,type){
    return this.http.post(this._baseURL+"/company/group/signees/" + companyId + "/" + groupId, {"signeesAssigned":signeesAssigned,requestype:type});
  }

  deleteGroup(companyId, groupId){
    return this.http.get(this._baseURL+'/company/group/delete/' + companyId + '/' + groupId);
  }

  updateGroupName(companyId, groupId, groupName){
    return this.http.patch(this._baseURL+'/company/group/' + companyId + '/' + groupId, {"name":groupName});
  }

  getAllCompaniesData(){
    return this.http.get(this._baseURL+'/compnayListing/all');
  }

  updateKitTilte(postdata,company_id){
    return this.http.post(this._baseURL+'/company/' + company_id + '/editkittitle',postdata);
  }

  companiesPlan(offset,limit){
    return this.http.get(this._baseURL+'/planbuyers/0/'+offset+'/'+limit);
  }

  getAllCompaniesPlanData(){
    return this.http.get(this._baseURL+'/planbuyers/all');
  }

  getUserInfoFromUserid(userid){
    return this.http.get(this._baseURL+'/get-user-info-id/'+userid);
  }

  saveChangePassword(user_id,data){
    return this.http.post(this._baseURL+'/user_id/'+user_id+'/change-password',data);
  }

  getCompaniesAccessInfo1(): Observable<CompanyAccessLimit[]> {
      return this.http.get<CompanyAccessLimit[]>(this._baseURL+'/api-call-limit').pipe(
        map(data => {
          if(data['success'] == true){
            return data['data'].map(data => new CompanyAccessLimit().deserialize(data))
          } else {
            this.messageObj = {
              'message' : data['message'],
              "success" : false
            }
            return Observable.of(this.messageObj);
          }
        })
      );
  }

  getCompaniesAccessInfo(){
    /*return this.http.get<CompanyAccessLimit[]>(this._baseURL+'/api-call-limit').pipe(
      map(data => data['data'].map(data => new CompanyAccessLimit().deserialize(data)))
    );*/
    return this.http.get(this._baseURL+'/api-call-limit');
  }

  getAllCompaniesAccessInfo1(): Observable<CompanyAccessLimit[]>{
    return this.http.get<CompanyAccessLimit[]>(this._baseURL+'/api-call-limit/all').pipe(
      map(data => {
        if(data['success'] == true){
          return data['data'].map(data => new CompanyAccessLimit().deserialize(data))
        } else {
          this.messageObj = {
            'message' : data['message'],
            "success" : false
          }
          return Observable.of(this.messageObj);
        }
      })
    );
  }


  getAllCompaniesAccessInfo(){
    return this.http.get(this._baseURL+'/api-call-limit/all');
  }

  addAccessLimit(totalApprove,compEmail, compID, id){
    return this.http.post(this._baseURL+'/add-access-limit', {"totalApprove":totalApprove,"compEmail":compEmail, "compID":compID, "id":id});
  }

  updateAccessLimit(totalApprove,id,compID, compEmail){
    return this.http.post(this._baseURL+'/add-access-limit', {"totalApprove":totalApprove,"compEmail":compEmail,"compID":compID ,"id":id});
  }

  getCompanyCallLog(email){
    return this.http.post(this._baseURL+'/api-call-log', {"compantEmail":email});
  }

  getAllCompaniesCallLog(email){
    return this.http.post(this._baseURL+'/api-call-log/all', {"compantEmail":email});
  }

  updateAccessStatus(ipAddr,is_block,id){
    return this.http.post(this._baseURL+'/api-ip-block', {"ipAddr":ipAddr,"is_block":is_block, "id":id});
  }

  getGroupTableData(companyId, groupId){
    return this.http.get(this._baseURL+'/company/group/gcf-stat/' + companyId + '/' + groupId);
  }

  updateCustomField(postData){
    return this.http.post(this._baseURL+'/update-custom-field-group-multiple',postData);
  }

  updateCustomFieldCompany(postData){
    return this.http.post(this._baseURL+'/update-custom-field-company',postData);
  }

  deleteCustomField(company_id,groupId,group_custom_id){
    return this.http.get(this._baseURL+'/company/group/customField/'+company_id+'/'+groupId+'/'+group_custom_id);
  }

  addCustomField(postData,company_id,groupId){
    return this.http.post(this._baseURL+'/company/group/add-custom-field/'+company_id+'/'+groupId,postData);
  }

  updateCustomFieldValue(postData){
    return this.http.post(this._baseURL+'/update-custom-field-value',postData);
  }

  uploadExcel(postData){
    return this.http.post(this._baseURL+'/importExcel',postData);
  }

  uploadExcelwithColumns(first_name,last_name,email,phone,path){
    return this.http.post(this._baseURL+'/importExceldb',{"first_name":first_name,"last_name":last_name,"email":email,"phone":phone,"path":path});
  }

  finalUploadExcelGroups(groupid,companyid,selected_array_temp,path_temp){
    return this.http.post(this._baseURL+'/finalimportExcel',{"group_id":groupid,"company_id":companyid,"path_temp":path_temp,"selected_array_temp":selected_array_temp});
  }

  inviteCompany(email){
    return this.http.post(this._baseURL+'/inviteCompany',{"email":email});
  }

  getQueueList(){
    return this.http.get(this._baseURL+'/get-queue-monitoring-list');
  }

  getAllQueueList(){
    return this.http.get(this._baseURL+'/get-queue-monitoring-list/all');
  }

  getDefaultGateway(){
    return this.http.get(this._baseURL+'/default-gateway');
  }

  updateDefaultGateway(mode){
    return this.http.post(this._baseURL+'/update-default-gateway',{"mode":mode});
  }

  updatePlanSetting(postData){
    return this.http.post(this._baseURL+'/planbuyers/modify',postData);
  }

  addcredittouser(postData){
    return this.http.post(this._baseURL+'/planbuyers/addcredittouser',postData);
  }

  getStorageComponent(company_id){
    return this.http.get(this._baseURL+'/getSecurityComponent/'+company_id);
  }

  saveAmazonCloud(company_id,postData){
    return this.http.post(this._baseURL+'/save-login-aws/'+company_id,postData);
  }

  saveBBCloud(company_id,postData){
    return this.http.post(this._baseURL+'/change-b2/'+company_id,postData);
  }

  saveDropBoxCloud(company_id,postData){
    return this.http.post(this._baseURL+'/change-drop-box/'+company_id,postData);
  }

  requestInputLogs(offset,sort){
    return this.http.get(this._baseURL+'/request-input-log/'+offset+'/'+sort);
  }

  postMappingLogs(postData){
    return this.http.post(this._baseURL+'/get-postmapping-logs',postData);
  }

  getPostMappingCompanies(){
    return this.http.get(this._baseURL+'/get-postmapping-companies');
  }

  searchRequestInputLog(request_from,request_to,email,offset,sort,log_type){
    return this.http.post(this._baseURL+'/search-request-input-logs',{"start_date":request_from,"end_date":request_to,'filteremail':email,'offset':offset,'sort':sort,'log_type':log_type});
  }

  activityLoginLogs(offset,sort){
    return this.http.get(this._baseURL+'/activity-login-log/'+offset+'/'+sort);
  }

  storageLogs(offset,sort){
    return this.http.get(this._baseURL+'/storage-process-log/'+offset+'/'+sort);
  }

  gettopNotificationsWithScroll(offset,company_id,role_id,user_id){
    return this.http.post(this._baseURL+'/getUserBasedNotifications',{"offset":offset,"company_id":company_id,'role_id':role_id,'user_id':user_id});
  }

  viewDocumentLogs(docid){
    return this.http.get(this._baseURL+'/storage-doc-log/'+docid);
  }

  searchLoginActivityLog(request_from,request_to,email,offset,sort,log_type){
    return this.http.post(this._baseURL+'/search-activity-login',{"start_date":request_from,"end_date":request_to,'filteremail':email,'offset':offset,'sort':sort,'log_type':log_type});
  }

  searchStorageLog(request_from,request_to,request_status,request_name,offset,sort,log_type){
    return this.http.post(this._baseURL+'/search-storage-log',{"start_date":request_from,"end_date":request_to,'request_status':request_status,'request_name':request_name,'offset':offset,'sort':sort,'log_type':log_type});
  }

  requestLogs(offset,sort){
    return this.http.get(this._baseURL+'/doc-request-log/'+offset+'/'+sort);
  }

  searchRequestLog(request_from,request_to,request_status,request_name,offset,sort,log_type){
    return this.http.post(this._baseURL+'/search-request-log',{"start_date":request_from,"end_date":request_to,'request_status':request_status,'request_name':request_name,'offset':offset,'sort':sort,'log_type':log_type});
  }

  viewRequestLogs(requestid){
    return this.http.get(this._baseURL+'/request-process-log/'+requestid);
  }

  getSigneeRecord(company_id){
    return this.http.get(this._baseURL+'/company/signeeAll/'+company_id)
  }

  updateSignee(first_name,last_name,email,id,is_user,phone){
    return this.http.post(this._baseURL+'/update-signee', {"first_name":first_name,"email":email,"last_name":last_name,"id":id,"is_user":is_user,"phone":phone})
  }

  getGoogleData(company_id){
    return this.http.get(this._baseURL+'/getGoogleData/'+company_id);
  }

  getAllSignee(company_id){
    return this.http.get(this._baseURL+'/company/signeeAll/'+company_id+'/all');
  }

  getAllUserList(){
    return this.http.get(this._baseURL+'/getAllUserList');
  }

  getOtherCompany(company_id){
    return this.http.get(this._baseURL+'/company/getothercompany/'+company_id);
  }

  getHubspotList(user_id,company_id){
    return this.http.post(this._baseURL+'/get-hupspot-list', {"user_id":user_id,"company_id":company_id})
  }

  createHubspotField(postData){
    return this.http.post(this._baseURL+'/create-hubspot-custom-field',postData)
  }

  getSendQuoteRequest(postData){
    return this.http.post(this._baseURL+"/check-user-deal", postData);
  }
  checkUserDeal(postData){
    return this.http.post(this._baseURL+"/check-user-deal", postData);
  }
  sendPreSignForm(postData){
    return this.http.post(this._baseURL+"/send-presign-form", postData);
  }

  savePreSignForm(postData){
    return this.http.post(this._baseURL+"/save-presign-form", postData);
  }
  sendInvoice(postData){
    return this.http.post(this._baseURL+"/send-invoice", postData);
  }
  documentPageDelete(postData){
    return this.http.post(this._baseURL+'/page-delete', postData);
  }
  documentPageOrder(postData){
    return this.http.post(this._baseURL+'/page-order', postData);
  }

  getExistingTemplateDetails(data){
    return this.http.post(this._baseURL+'/get-template-details',data);
  }

  UpdateTemplateSetting(data){
    return this.http.post(this._baseURL+'/update-template-setting',data);
  }

  updateGSuiteSetting(gsuite_doc_setting){
    return this.http.post(this._baseURL+'/update-gsuite-mode', {"gsuite_mode":gsuite_doc_setting});
  }

  reOpenExpireRequest(postData){
    return this.http.post(this._baseURL+"/reopen-expired-request",postData);
  }

  getCompleteDocPath(postData){
    return this.http.post(this._baseURL+"/get-complete-doc-path",postData);
  }

  getOrignalDocPath(postData){
    return this.http.post(this._baseURL+"/get-orignal-file",postData);
  }

  loginByEmailWithCustomClaims(postData){
    return this.http.post(this._baseURL+"/loginusingcustomclaims",postData);
  }
  getCompniesWithPlans(){
    return this.http.get(this._baseURL+'/get-companies-with-plans');
  }

  /*saveCompanyBasicPlan(planvalue,plantitle,plandesc,planrecurring_type,user_allowed){
    return this.http.post(this._baseURL+'/create-company-basic-plan', {"planvalue":planvalue,"plantitle":plantitle,"plandesc":plandesc,"planrecurring_type":planrecurring_type,"user_allowed":user_allowed});
  }*/

  saveCompanyBasicPlan(planprices,plantitle,plandesc,user_allowed,request_allowed,license){
    return this.http.post(this._baseURL+'/create-company-basic-plan', {"planprices":planprices,"plantitle":plantitle,"plandesc":plandesc,"user_allowed":user_allowed,"request_allowed":request_allowed,"license":license});
  }

  saveCouponCode(pvalue,coupon_name,coupon_type,duration,duration_in_months){
    return this.http.post(this._baseURL+'/save-new-coupon', {"pvalue":pvalue,"coupon_name":coupon_name,"coupon_type":coupon_type,"duration":duration,"duration_in_months":duration_in_months});
  }

  saveCompanyPlanInfo(companyid,planid,planprice,price_id,cardid){
    return this.http.post(this._baseURL+'/save-company-plan-info', {"companyid":companyid,"plan_id":planid,"plan_price":planprice,"cardid":cardid,"price_id":price_id});
  }

  startSubscription(companyid,items,cardid,grandTotal,discountApply,action?){
    let actiontype;
    if(typeof action != 'undefined'){
      actiontype = action;
    } else {
      actiontype = 'normal';
    }
    return this.http.post(this._baseURL+'/save-company-plan-info', {"companyid":companyid,"items":items,"cardid":cardid,"grandTotal":grandTotal,"discountApply":discountApply,"action":actiontype});
  }

  updateSubscription(companyid,items,cardid,grandTotal,subscription_id,discountApply,action?){
    let actiontype;
    if(typeof action != 'undefined'){
      actiontype = action;
    } else {
      actiontype = 'normal';
    }
    return this.http.post(this._baseURL+'/update-company-plan-info', {"companyid":companyid,"items":items,"cardid":cardid,"grandTotal":grandTotal,'subscription_id':subscription_id,"discountApply":discountApply,"action":actiontype});
  }

  startCreditPlan(companyid,items,cardid,grandTotal,discountApply,is_credit_plan?,action?){
    let actiontype;
    if(typeof action != 'undefined'){
      actiontype = action;
    } else {
      actiontype = 'normal';
    }
    return this.http.post(this._baseURL+'/save-company-plan-info', {"companyid":companyid,"items":items,"cardid":cardid,"grandTotal":grandTotal,"discountApply":discountApply,"action":actiontype,"is_credit_plan":is_credit_plan});
  }
  getCompanyCards(companyid,role_id=''){
    return this.http.post(this._baseURL+'/get-company-cards', {"companyid":companyid,'role_id':role_id});
  }

  getSubscriptionList(companyid){
    return this.http.post(this._baseURL+'/get-subscription-list', {"companyid":companyid});
  }

  getTransactionList(companyid){
    return this.http.post(this._baseURL+'/get-tranaction-list', {"companyid":companyid});
  }

  getSubscriptionProducts(subscription_id){
    return this.http.post(this._baseURL+'/get-subscription-products', {"subscription_id":subscription_id});
  }

  getSubscriptionFeaturesAllowed(postData){
    return this.http.post(this._baseURL+'/get-subscription-features-allowed', postData);
  }


  updateCompanyPlan(companyid,planid){
    return this.http.post(this._baseURL+'/update-company-basic-plan', {"company_id":companyid,"planid":planid});
  }

  getBasicPlanListing(){
    return this.http.get(this._baseURL+'/get-basic-plan-listing');
  }

  getCouponsListing(){
    return this.http.get(this._baseURL+'/get-coupon-list');
  }

  updateReminderSettingRequest(postData){
    return this.http.post(this._baseURL+"/update-reminder-setting",postData);
  }

  sendReminderRequest(postData){
    return this.http.post(this._baseURL+"/send-reminder-now",postData);
  }
  deleteCoupon(postData){
    return this.http.post(this._baseURL+"/remove-coupon",postData);
  }
  getBasicPlanList(){
    return this.http.get(this._baseURL+'/get-basic-plan-list');
  }
  getBasicPlanListCompany(){
    return this.http.get(this._baseURL+'/get-basic-plan-list-company');
  }

  getPlanStatus(){
    return this.http.get(this._baseURL+'/check-plan-status');
  }

  getCompanyPlanInfo(postdata){
    return this.http.post(this._baseURL+'/get-company-plan-info',postdata);
  }
  updateCompanyBasicPlan(planid,priceid,planprices,plantitle,plan_desc,planversion,user_allowed,request_allowed,license){
    return this.http.post(this._baseURL+'/update-company-basic-plan', {"plan_id":planid,"price_id":priceid,"planprices":planprices,"plantitle":plantitle,"plan_desc":plan_desc,"user_allowed":user_allowed,"request_allowed":request_allowed,"planversion":planversion,"license":license});
  }

  cancelCompanyPlan(companyid,planid,company_plan_id,subscription_id,customer_id,card_id){
    return this.http.post(this._baseURL+'/cancel-company-plan', {"plan_id":planid,"company_id":companyid,"id":company_plan_id,"subscription_id":subscription_id,"customer_id":customer_id,"card_id":card_id});
  }
  logFrontEndError(error: any){

    var fullRoute = this.router.url;
    // Here you can provide whatever logging you want
    let errormessage = '';
    let errorstack = '';
    if (error instanceof TypeError) {
      errormessage += 'There was a Type error. '+ error.message;
      errorstack += error.stack;
    } else if (error instanceof Error) {
      errormessage += 'There was a general error. '+ error.message;
      errorstack += error.stack;
    } else {
        errormessage += 'some error happened!'+ error.message;
        errorstack += error.stack;
    }

    console.log('errormessage',errormessage);
    console.log('errorstack',errorstack);
    console.log('fullRoute',fullRoute);
    return this.http.post(this._baseURL+"/log-frontend-error",{"path":fullRoute,"message":errormessage,"stack":errorstack});

  }

  saveExpirationDays(expiration_time){
    return this.http.post(this._baseURL+'/saveexpirationdays', {"expiration_time":expiration_time});
  }

  getExpirationDays(){
    return this.http.get(this._baseURL+"/getexpirationdays");
  }

  signaspo(postData){
    return this.http.post(this._baseURL+"/mark-request-as-po",postData);
  }
  getRoles(){
    return this.http.get(this._baseURL+'/getRoles');
  }
  assignLicence(postData){
    return this.http.post(this._baseURL+"/assign-license",postData);
  }
  changeRole(postData){
    return this.http.post(this._baseURL+"/change-role",postData);
  }
  sendRequestForSignatureToSignee(postData){
    return this.http.post(this._baseURL+"/send-request-to-signee",postData);
  }

  companyMaxUsers(postData){
    return this.http.post(this._baseURL+"/company-max-users",postData);
  }

  uploadDocumentQuick(fd,company_id){
    return this.http.post(this._baseURL+'/company/document/upload/'+ company_id, fd)
  }
  getgoogledoclist(postData){
    return this.http.post(this._baseURL+"/get-directory-list",postData);
  }
  getsubFolders(folderId){
    return this.http.get(this._baseURL+"/google-drive-settings/"+folderId);
  }

  getRuleResultsByRequestId(docid,requestid){
    return this.http.post(this._baseURL+'/rule-result-by-request-id', {"document_id":docid,"request_id":requestid});
  }

  getAllAdminFeature(ftype?){
    if(typeof ftype != 'undefined'){
      return this.http.get(this._baseURL+"/get-feature/"+ftype);
    } else {
      return this.http.get(this._baseURL+"/get-feature");
    }

  }

  updatePlanFeatures(postdata){
    return this.http.post(this._baseURL+'/update-plan-features', postdata);
  }

  checkIsPaidUser(companyid){
    return this.http.post(this._baseURL+'/check-is-paid-user', {"companyid":companyid});
  }

  getPostMappingHistoryRequest(postData){
    return this.http.post(this._baseURL+"/get-post-mapping-history",postData);
  }

  checkValidDiscountCode(discountCode){
    return this.http.post(this._baseURL+'/check-valid-discount-code', {"discountcode":discountCode});
  }

  saveCompanyKeys(postData){
    return this.http.post(this._baseURL+"/save-company-keys",postData);
  }

  savePlaidKeys(postData){
    return this.http.post(this._baseURL+"/save-company-keys-plaid",postData);
  }

  getCompanyStripe(){
    return this.http.get(this._baseURL+"/get-company-keys");
  }

  saveSignee(postData){
    return this.http.post(this._baseURL+"/save-signee-to-company",postData);
  }

  getTMDFeeSetting(postData){
    return this.http.post(this._baseURL+"/get-tmdfee-setting",postData);
  }

  updateTMDFeeSetting(postData){
    return this.http.post(this._baseURL+"/save-tmdfee-setting",postData);
  }

  createLinkToken(postData){
    return this.http.post(this._baseURL+"/create-link-token-plaid",postData);
  }

  plaidBankAdd(postData){
    return this.http.post(this._baseURL+"/plaid-public-token-exchange",postData);
  }

  getCompanyPlaid(){
    return this.http.get(this._baseURL+"/get-company-plaid-keys");
  }

  useCompanyDocs(postData){
    return this.http.post(this._baseURL+"/company/group/docs",postData);
  }
  saveSlackKeys(postData){
    return this.http.post(this._baseURL+'/save-slack-keys',postData);
  }
  getSlackKeys(){
    return this.http.get(this._baseURL+'/get-slack-keys');
  }

  getUserSlackKeys(postData){
    return this.http.post(this._baseURL+'/get-user-slack-token-info',postData);
  }

  slackTokenRevoke(){
    return this.http.get(this._baseURL+'/revoke-slack-auth');
  }

  slackTokenRevokeForAll(){
    return this.http.get(this._baseURL+'/revoke-slack-auth-all');
  }

  slackConversationsList(){
    return this.http.get(this._baseURL+'/slack-conversations-list');
  }

  updateDefaultChannel(postData){
    return this.http.post(this._baseURL+'/update-default-channel',postData);
  }

  enableDefaultChannel(postData){
    return this.http.post(this._baseURL+'/enable-tmdai',postData);
  }

  disbaledTmdaiChannel(postData){
    return this.http.post(this._baseURL+'/remove-tmdai',postData);
  }

  changeTmdaiChannel(postData){
    return this.http.post(this._baseURL+'/change-tmdai',postData);
  }

  getDocComments(request_id){
    return this.http.get(this._baseURL+'/get-comments-doc-based/'+request_id);
  }
    getDocBasedComments(requestID){
    return this.http.get(this._baseURL+"/get-comments-doc-based/"+requestID);
  }

  getCreditPlanListing(){
    return this.http.get(this._baseURL+'/get-credit-plan-listing');
  }
  saveCreditPlan(planprices,plantitle,plandesc){
    return this.http.post(this._baseURL+'/create-credit-plan', {"planprices":planprices,"plantitle":plantitle,"plandesc":plandesc});
  }
  updateCreditPlan(planid,priceid,planprices,plantitle,plan_desc,planversion){
    return this.http.post(this._baseURL+'/update-credit-plan', {"plan_id":planid,"price_id":priceid,"planprices":planprices,"plantitle":plantitle,"plan_desc":plan_desc,"planversion":planversion});
  }
  getCreditPlanList(){
    return this.http.get(this._baseURL+'/get-basic-creditplan-list');
  }
  getCreditCouponsListing(){
    return this.http.get(this._baseURL+'/get-credit-coupon-list');
  }
  getLicenseListing(){
    return this.http.get(this._baseURL+'/get-license');
  }
  saveLicense(license_name){
    return this.http.post(this._baseURL+'/save-new-license', {"license_name":license_name});
  }
  deleteLicense(postData){
    return this.http.post(this._baseURL+"/remove-license",postData);
  }
  getSingleLicense(licenseid){
    return this.http.get(this._baseURL+'/get-single-license/'+licenseid);
  }
  updateLicense(postData){
    return this.http.post(this._baseURL+'/update-license-type', postData);
  }
  getAllowedLicensesForUsers(postData){
    return this.http.post(this._baseURL+"/get-user-specific-license",postData);
  }

  getExistingCreditPlans(postData){
    return this.http.post(this._baseURL+"/company-existing-credit-plan",postData);
  }
  saveDealHubLandingSetting(postData){
    return this.http.post(this._baseURL+"/save-dealhub-configuration",postData);
  }

  getCompanyDealHubSettings(postData){
    return this.http.post(this._baseURL+'/get-company-dealhub-configuration',postData);
  }

  sendDealHubRequest(postData){
    return this.http.post(this._baseURL+"/send-dealhub-request", postData);
  }
  getAllIndividualDetails(offset,limit){
    return this.http.get(this._baseURL+'/individualListing/'+offset+'/'+limit);
  }

  getAllIndividualData(){
    return this.http.get(this._baseURL+'/individualListing/all');
  }

  cancelCompanyCreditPlan(companyid,planid,company_plan_id,subscription_id,customer_id,card_id,credit_plan_id){
    return this.http.post(this._baseURL+'/cancel-company-credit-plan', {"plan_id":planid,"company_id":companyid,"id":company_plan_id,"subscription_id":subscription_id,"customer_id":customer_id,"card_id":card_id,"credit_plan_id":credit_plan_id});
  }

  getUserInfoCompany(userid,companyid){
    return this.http.get(this._baseURL+'/getUserInfo/'+userid+'/'+companyid);
  }

  resendRequestWithSignee(postData){
    return this.http.post(this._baseURL+"/resend-request-with-signee", postData);
  }

  getrequestTemplateSignees(postData){
    return this.http.post(this._baseURL+"/get-request-template-signee", postData);
  }

  getDealInfo(postData){
    return this.http.post(this._baseURL+"/get-deal-info", postData);
  }

  getEmailTemplates(postData){
    return this.http.post(this._baseURL+"/get-company-email-template-list", postData);
  }

  saveDigitalConsent(postData){
    return this.http.post(this._baseURL+'/save-digital-consent', postData);
  }

  changeDigitalConsent(postData){
    return this.http.post(this._baseURL+"/update-digital-consent", postData);
  }


  resendRequestSigningLink(postData){
    return this.http.post(this._baseURL+"/resend-new-request-link", postData);
  }

  resendRequestToSignee(postData){
    return this.http.post(this._baseURL+"/resend-request-link-to-signee", postData);
  }

  updateDealHubNickName(dealhubid,postData){
    return this.http.post(this._baseURL+"/update-dealhub-nikname/"+dealhubid,postData);
  }

  async getCompanyActiveUsers(postData){
    return await this.http.post(this._baseURL+"/get-company-users",postData).toPromise();
  }

  getExcludedDomainList(){
    return this.http.get(this._baseURL+"/get-excluded-domains-list");
  }

  getReviewerDealHubHash(postData){
    return this.http.post(this._baseURL+"/get-reviewer-dealhub-hash", postData);
  }


  attachNDARequestToHubSpot(postData){
    return this.http.post(this._baseURL+'/attach-nda-request-to-hubspot',postData);
  }

  makeTemplateArchieve(postData){
    return this.http.post(this._baseURL+"/company/template/archive",postData);
  }
  viewAndVerifyDealCreation(postData){
    return this.http.post(this._baseURL+"/younium-deal-tool",postData);
  }

  getDealCompanyInvoices(postData){
    return this.http.post(this._baseURL+"/get-deal-company-invoices",postData);
  }

  getInvoiceURLByID(postData){
    return this.http.post(this._baseURL+"/get-younium-invoice-detail-by-id",postData);
  }

  copyDealProperties(postData){
    return this.http.post(this._baseURL+'/copy-deal-properties',postData);
  }

  getpcmResult(postData){
    return this.http.post(this._baseURL+"/run-post-completion-mapping",postData);
  }

  getSavedPipeLinesFromSettings(postData){
    return this.http.post(this._baseURL+"/get-saved-pipelines-from-settings",postData);
  }

  updateDealHubQuoteData(postData){
    return this.http.post(this._baseURL+"/update-dealhub-quote-data",postData);
  }

  syncToPaymentFrequncy(postData){
    return this.http.post(this._baseURL+"/sync-payment-frequency-with-template", postData);
  }

  createDocGroupRequest(postData){
    return this.http.post(this._baseURL+"/company/documents/create",postData);
  }

  checkUniqueName(postData){
    return this.http.post(this._baseURL+"/company/documents/check-unique",postData);
  }

  getGroupDocumentListing(){
    return this.http.get(this._baseURL+"/company/documents/list");
  }

  switchStatus(postData){
    return this.http.post(this._baseURL+"/company/documents/switch-status",postData);
  }
 
  requestDocument(postData){
    return this.http.post(this._baseURL+"/company/documents/request-document",postData);
  }

  requestDocumentUpdate(postData,id){
    return this.http.post(this._baseURL+"/company/documents/update/"+id,postData);
  }

  getRequestDocumentListing(postData){
    return this.http.post(this._baseURL+"/company/documents/request-listing",postData);
  }

  getApproveDoc(postData){
    return this.http.post(this._baseURL+"/company/documents/updatestatus",postData);
  }
  getGroupDocListing(postData){
    return this.http.post(this._baseURL+"/company/documents/group-request-listing",postData);
  }
  getHSCompanyListing(postData){
    return this.http.post(this._baseURL+"/company/documents/get-company-listing",postData);
  }
 
  expireRequest(postData){
    return this.http.post(this._baseURL+"/company/documents/expire-document-url",postData);
  }
  getDocfielddata(postData){
    return this.http.post(this._baseURL+'/company/document/getfielddata',postData);
  }

}

